import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { OPERATIONAL_ROLES } from "@/lib/roles";

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div style={{ height: "100vh", display: "grid", placeItems: "center", background: "var(--invict-bone)" }}>
        <div className="skel" style={{ width: 200, height: 12 }} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={defaultPath(user.role)} replace />;
  }
  return children;
}

export function defaultPath(role) {
  if (role === "admin") return "/admin";
  if (role === "supervisor") return "/supervisor";
  if (OPERATIONAL_ROLES.includes(role)) return "/vigilador";
  if (role === "cliente" || role === "cliente_admin" || role === "inquilino") return "/cliente";
  return "/login";
}
